import {Scene} from "../DB/scenes/@Scene";
import {Command, CommandMeta, DeriveJSONSchema, SimpleSchema} from "mobx-graphlink";

const MTClass = Scene;
type MT = typeof MTClass.prototype;

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		entry: DeriveJSONSchema(MTClass, {}),
	}),
	responseSchema: ()=>SimpleSchema({id: {$ref: "UUID"}}),
})
export class AddScene extends Command<{entry: MT}, {id: string}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		$id: {$ref: "UUID"},
		$updates: DeriveJSONSchema(MTClass, {excludeKeys: ["id", "creator", "createdAt"], makeOptional_all: true}),
	}),
})
export class UpdateScene extends Command<{id: string, updates: Partial<MT>}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		id: {$ref: "UUID"},
	}),
})
export class DeleteScene extends Command<{id: string}> {}